import { mapState, mapMutations } from 'vuex'
import { WIDGET_STATE_CHANGED_RULES } from '@/enums'

export default {
  computed: {
    ...mapState({
      _currentState: (state) => state.Widget.widgetState,
      _isChatReportEnabled: (state) => state.Widget.chatReport,
    }),
    _isCurrentStateValid() {
      return [
        this.$enum.WIDGET_STATE.INIT,
        this.$enum.WIDGET_STATE.HIDDEN,
      ].includes(this._currentState)
    },
  },
  methods: {
    ...mapMutations({
      _UPDATE_WIDGET_STATE: 'Widget/UPDATE_WIDGET_STATE',
    }),
    _isTargetStateValid(status) {
      return [
        this.$enum.WIDGET_STATE.TEASER,
        this.$enum.WIDGET_STATE.FULLFRAME,
      ].includes(status)
    },
    _isAWidgetOpportunity(status, reason) {
      if (reason !== this.$enum.CHAT_REPORT.WIDGET_OPPORTUNITY) return false
      return this._isTargetStateValid(status) && this._isCurrentStateValid
    },
    _getWidgetOpportunityReason({ isAllowed, mode, outOfSchedule }) {
      switch (mode) {
        case WIDGET_STATE_CHANGED_RULES.NONE:
          return this.$enum.CHAT_REPORT.WIDGET_OPPORTUNITY

        case WIDGET_STATE_CHANGED_RULES.ONLY_SCHEDULE:
          return isAllowed
            ? this.$enum.CHAT_REPORT.WIDGET_OPPORTUNITY
            : this.$enum.CHAT_REPORT.WIDGET_OUT_OF_PLANNING

        case WIDGET_STATE_CHANGED_RULES.SCHEDULE_AND_AGENT:
          return isAllowed
            ? this.$enum.CHAT_REPORT.WIDGET_OPPORTUNITY
            : outOfSchedule
            ? this.$enum.CHAT_REPORT.WIDGET_OUT_OF_PLANNING
            : this.$enum.CHAT_REPORT.WIDGET_NO_AGENT_AVAILABLE
        default:
          return undefined
      }
    },
    _getEngagementOpportunityReason({ isAgentAvailable, isOutOfSchedule }) {
      if (isAgentAvailable && !isOutOfSchedule) {
        return this.$enum.CHAT_REPORT.LIVECHAT_SERVED
      } else if (isOutOfSchedule) {
        return this.$enum.CHAT_REPORT.ENGAGEMENT_OUT_OF_PLANNING
      } else if (!isAgentAvailable) {
        return this.$enum.CHAT_REPORT.ENGAGEMENT_NO_AGENT_AVAILABLE
      }

      return undefined
    },
    _isWidgetStateChangeAllowed({ mode, outOfSchedule, agentAvailable }) {
      switch (mode) {
        case WIDGET_STATE_CHANGED_RULES.NONE:
          return true

        case WIDGET_STATE_CHANGED_RULES.ONLY_SCHEDULE:
          return !outOfSchedule

        case WIDGET_STATE_CHANGED_RULES.SCHEDULE_AND_AGENT:
          return agentAvailable && !outOfSchedule

        default:
          return false
      }
    },
    _sendReport(status) {
      if (!status) return
      if (!this._isChatReportEnabled) return
      return this.$api.chatReport.createReport(status)
    },
    async $_chatReportMixin_changeWidgetStateAndReport(
      status,
      mode = WIDGET_STATE_CHANGED_RULES.NONE,
      { outOfSchedule, agentAvailable } = {},
    ) {
      if (!status) return

      const isStateChangeAllowed = this._isWidgetStateChangeAllowed({
        mode,
        outOfSchedule,
        agentAvailable,
      })

      const widgetOpportunityReason = this._getWidgetOpportunityReason({
        mode,
        isAllowed: isStateChangeAllowed,
        outOfSchedule,
      })

      if (isStateChangeAllowed) {
        if (this._isAWidgetOpportunity(status, widgetOpportunityReason)) {
          await this._sendReport(widgetOpportunityReason)
        }

        console.info(`chatReportMixin: Change widget state to ${status}`)
        this._UPDATE_WIDGET_STATE(status)
      } else {
        await this._sendReport(widgetOpportunityReason)
      }
    },
    async $_chatReportMixin_reportEngagement({
      isAgentAvailable,
      isOutOfSchedule,
    }) {
      const engagementOpportunityReason = this._getEngagementOpportunityReason({
        isAgentAvailable,
        isOutOfSchedule,
      })

      await this._sendReport(engagementOpportunityReason)
    },
  },
}
